
import { Component, PropSync, Prop, Watch, Vue } from "vue-property-decorator";
import { appComposeGroupList, composeListStore } from "@/api/appCompose";

@Component
export default class TcmBrainSetting extends Vue {
  @PropSync("visible", { type: Boolean }) dialogVisible!: boolean;
  @Prop() storeRow?: Record<string, unknown>;

  searchTitle = "";
  groupId: string | number = "";
  loading = false;
  groupTypeList: Array<{ groupId: string | number; groupName: string; sortNum?: number }> = [];
  tableData: Array<Record<string, unknown>> = [];

  get dialogTitle(): string {
    return (this.storeRow?.storeShowName as string) || "-";
  }

  @Watch("dialogVisible")
  onDialogVisibleChange(val: boolean) {
    if (val) {
      this.searchTitle = "";
      this.groupId = "";
      this.fetchGroupTypeList();
      this.fetchList();
    }
  }

  closeDialog() {
    this.searchTitle = "";
    this.groupId = "";
  }

  fetchGroupTypeList() {
    const merchantId = this.storeRow?.merchantId;
    appComposeGroupList({ merchantId: merchantId || 0 }).then((res: any) => {
      const list: Array<{ groupId: string | number; groupName: string; sortNum?: number }> = [];
      (res?.data ?? []).forEach((el: any) => {
        list.push({
          groupId: el.id,
          groupName: el.name,
          sortNum: el.sortNum,
        });
      });
      list.sort((a, b) => (a.sortNum ?? 0) - (b.sortNum ?? 0));
      this.groupTypeList = list;
    });
  }

  fetchList() {
    this.loading = true;
    const params = {
      appType: 0,
      groupId: this.groupId,
      storeId: this.storeRow?.id ?? 0,
      title: this.searchTitle || "",
    };
    composeListStore(params)
      .then((res: any) => {
        const rawData = res?.data?.list ?? res?.data ?? [];
        this.tableData = Array.isArray(rawData)
          ? rawData.flat(Infinity)
          : [];
      })
      .catch(() => {
        this.tableData = [];
      })
      .finally(() => {
        this.loading = false;
      });
  }

  handleSearch() {
    this.fetchList();
  }

  // groupId 转中文，优先从 groupTypeList 匹配，否则用静态映射
  groupIdToNameMap: Record<string | number, string> = {
    1: "智能体测系统",
    2: "智能调理系统",
    3: "其他功能",
  };

  getGroupName(groupId: string | number): string {
    if (groupId === null || groupId === undefined || groupId === "") return "-";
    const item = this.groupTypeList.find((el) => el.groupId == groupId);
    if (item?.groupName) return item.groupName;
    return this.groupIdToNameMap[groupId] ?? String(groupId);
  }
}
